import { chileYmd } from '@/lib/dateUtils';
import { resolveComuna } from '@/pages/diligencias/comunas';

export const MAX_TEXT = 300;

// One address per form: the API allows one live task per case (a second one
// answers 409 TaskAlreadyRunning), so there is one row. The cap rises with
// the API.
let seq = 0;
export function newRow() {
  seq += 1;
  return {
    key: `row-${seq}`,
    address: '',
    details: '',
    comuna: '',
  };
}

// "Today" of Chile as YYYY-MM-DD, the day the API compares against.
export const chileToday = (now = new Date()) => chileYmd(now);

// Errors by field, nothing when valid:
//   { deadline?: string, rows: { [key]: { address?, details?, comuna? } } }
export function validateDiligence({ deadline, rows }, today = chileToday()) {
  const errors = { rows: {} };
  if (!deadline) errors.deadline = 'Indica el plazo.';
  else if (deadline < today)
    errors.deadline = 'El plazo ya pasó. Elige hoy o una fecha futura.';

  rows.forEach((row) => {
    const e = {};
    if (!row.address.trim()) e.address = 'Indica la calle y el número.';
    else if (row.address.trim().length > MAX_TEXT)
      e.address = `Máximo ${MAX_TEXT} caracteres.`;
    if (row.details.trim().length > MAX_TEXT)
      e.details = `Máximo ${MAX_TEXT} caracteres.`;
    const resolved = resolveComuna(row.comuna);
    if (!row.comuna.trim()) e.comuna = 'Indica la comuna y la región.';
    else if (!resolved) e.comuna = 'Elige una comuna de la lista.';
    if (Object.keys(e).length) errors.rows[row.key] = e;
  });
  return errors;
}

export const hasErrors = (errors) =>
  Boolean(errors.deadline) || Object.keys(errors.rows).length > 0;

// The body of the POST, with no key the API does not know (it answers 400 for
// an unknown one). `deadline` and `notes` go on each address, no top-level
// ones. `deadline` goes as the UTC midnight of the chosen day, the way the
// other diligence forms send it: the API reads the business day from the UTC
// date.
export function buildBody({ intakeId, deadline, notes, rows }) {
  return {
    intakeId,
    addresses: rows.map((row) => {
      const resolved = resolveComuna(row.comuna);
      const out = {
        address: row.address.trim(),
        commune: resolved.comuna,
        region: resolved.region,
        deadline: new Date(deadline).toISOString(),
      };
      if (row.details.trim()) out.addressDetails = row.details.trim();
      if (notes.trim()) out.notes = notes.trim();
      return out;
    }),
  };
}
